const { __ } = wp.i18n;
import { useEffect, useState } from "@wordpress/element";
import { API } from "./API";
import FaqsTopics from "./FaqsTopics";
import FaqsList from "./FaqsList";

function Faqs() {

  const faqsAPI = new API();
  const [isLoading, setIsLoading] = useState(true);
  const [activeTopic, setActiveTopic] = useState();
  const [allTopics, setAllTopics] = useState([]);
  const [allFaqs, setAllFaqs] = useState([]);
  const [foundFaqs, setFoundFaqs] = useState([]);
  const [query, setQuery] = useState('');

  const loadContent = (topic) => {
    if (topic === 'busqueda') {
      setAllFaqs(foundFaqs);
      setActiveTopic(topic);
    } else {
      setActiveTopic(topic);
      faqsAPI.loadContent(topic).then(response => setAllFaqs(response.data));
      
      // Limpiar query param y actualizar hash
      const url = new URL(window.location);
      url.searchParams.delete('q');
      url.hash = `#${topic}`;
      window.history.pushState({}, '', url);
      setQuery('');
    }

  }

  const searchQuery = (query) => {
    const allTopicsCopy = [...allTopics];
    const hasSearchTopic = allTopicsCopy.find(topic => topic.slug === 'busqueda');

    if (!hasSearchTopic) {
      allTopicsCopy.unshift({
        id: 'key-busqueda',
        slug: 'busqueda',
        name: __('Resultados de la búsqueda', 'bizum-website'), // This needs to be translatable
        icon: 'add'
      });
    }

    setQuery(query);
    setAllTopics(allTopicsCopy);
    setActiveTopic('busqueda');

    // Actualizar URL con el query param
    const url = new URL(window.location);
    if (query) {
      url.searchParams.set('q', query);
      url.hash = ''; // Limpiar el hash cuando se busca
    } else {
      url.searchParams.delete('q');
    }
    window.history.pushState({}, '', url);

    faqsAPI.searchContent(query).then(response => {
      setFoundFaqs(response.data);
      setAllFaqs(response.data)
    });

    if (!query) {
      resetQuery();
    }

  }

  const resetQuery = () => {
    const initialParam = faqsAPI.getFragmentFromUrl() ? faqsAPI.getFragmentFromUrl() : false;

    // Limpiar query param al resetear
    const url = new URL(window.location);
    url.searchParams.delete('q');
    window.history.pushState({}, '', url);
    setQuery('');

    faqsAPI.loadTopics().then(response => {
      const initialTopic = initialParam ? initialParam : response.data[0].slug;
      setAllTopics(response.data);
      setActiveTopic(initialTopic);
      faqsAPI.loadContent(initialTopic).then(response => {
        setAllFaqs(response.data)
        setIsLoading(false);
      });
    });
  }

  useEffect(() => {
    // Verificar si hay query param 'q' en la URL al cargar
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('q');
    
    if (searchParam) {
      // Si hay búsqueda, cargar topics primero y luego buscar
      faqsAPI.loadTopics().then(response => {
        setAllTopics(response.data);
        setIsLoading(false);
        searchQuery(searchParam);
      });
    } else {
      // Si no hay búsqueda, cargar normalmente
      resetQuery();
    }
    
    // Escuchar evento personalizado de búsqueda
    const handleFaqsSearch = (event) => {
      searchQuery(event.detail.query);
    };
    
    window.addEventListener('faqsSearch', handleFaqsSearch);
    
    // Cleanup
    return () => {
      window.removeEventListener('faqsSearch', handleFaqsSearch);
    };
  }, []);

  return (
    <>
      <div className="content-faqs__grid">
        <FaqsTopics topics={allTopics} activeTopic={activeTopic} onClick={loadContent} />
        {!isLoading ? (<FaqsList faqs={allFaqs} />) : null}
      </div>
    </>
  )
}

export default Faqs